/* eslint-disable require-yield */
import { toast } from "react-toastify";
import { all, call, put, takeLatest } from "redux-saga/effects";
import { getPoiTypeLayerDataFn } from "../../apis/GeoDataAPI";
import { GeoData } from "../../constants/action-constants/GeoDataActionConstants";
import poiTypeLayerResponseConverter from "../../utils/PoiTypeLayerResponseConverter";
import { getErrorMessage } from "../../utils/util";

/**
 * @param {*} resPoiLayers => array of multiple string "poiTypeLayers"
 * @param {*} bbox => city bbox
 * @returns the array of all combined poi's points
 */
function* getAllPoiTypeLayersPoints(resPoiLayers, bbox) {
  // Step 1: call all APIs in parallel
  const responses = yield all(
    resPoiLayers.map((layer) => call(getPoiTypeLayerDataFn, layer, bbox))
  );

  // Step 2: process all responses in parallel
  const allPointsNested = yield all(
    responses.map((response) => call(poiTypeLayerResponseConverter, response))
  );

  // Step 3: flatten array
  const allPointsArr = allPointsNested.flat();

  return allPointsArr;
}

// for getting poitypelayer data for specific city
export function* getPoiTypeLayerData(action) {
  const { resPoiLayers, bbox } = action.payload;

  try {
    // for multiple PoiTypeLayer Ids
    const allPoiPointsArr = yield getAllPoiTypeLayersPoints(resPoiLayers, bbox);

    yield put({
      type: GeoData.GET_POI_TYPE_LAYER_DATA_SUCCESS,
      payload: { allPoiPointsArr },
    });
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    yield put({
      type: GeoData.GET_POI_TYPE_LAYER_DATA_FAILURE,
      payload: error,
    });
    toast.error(errorMessage);
  }
}

export default function* root() {
  yield all([takeLatest(GeoData.GET_POI_TYPE_LAYER_DATA, getPoiTypeLayerData)]);
}
